export var fftDocs = {
  name: 'fft',
  category: 'Matrix',
  syntax: ['fft(x)'],
  description: 'Calculate N-dimensional fourier transform',
  examples: ['fft([[1, 0], [1, 0]])'],
  seealso: ['ifft']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/embeddedDocs/function/matrix/fft.js
// module id = 1618
// module chunks = 2